<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                                             :table-items="tableItems"
                                             @load-items="getTableData"
                                             @row-click="clickToRowItem"
                                             ref="gofixTable">
                            <template slot="gofix_table:name" slot-scope="row">
                                {{row.item.name ? row.item.name : 'Cron System'  }}
                            </template>
                            <template slot="gofix_table:import_logs.created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:data" slot-scope="row">
                                <div class="d-flex table-import-log-status" v-if="row.item.data && row.item.data.count">
                                    <p class="mb-0 mr-2 d-flex align-items-center">
                                        <span class="mr-2 icon-dot icon-dot-succeeded"></span>
                                        <span>{{row.item.data.count.succeeded}} succeeded</span>
                                    </p>
                                    <p class="mb-0 mr-2 d-flex align-items-center">
                                        <span class="mr-2 icon-dot icon-dot-warning"></span>
                                        <span>{{row.item.data.count.warning}} warning</span>
                                    </p>
                                    <p class="mb-0 d-flex align-items-center">
                                        <span class="mr-2 icon-dot icon-dot-failed"></span>
                                        <span>{{row.item.data.count.failed}} failed</span>
                                    </p>
                                </div>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true"
                     modal-class="modal-create modal-import-logs"
                     title="Import Log Detail"
                     hide-footer
                     :centered="true"
                     size="xl"
                     v-model="modals.detail.open"
                     @hidden="resetDetailModal">
                <div class="import-log-modal" v-if="modals.detail.data">
                    <div class="import-log-summary">
                        <button
                            v-for="tab in statusTabs"
                            :key="tab.value"
                            type="button"
                            class="summary-tab"
                            :class="[tab.value, { active: activeStatus === tab.value }]"
                            @click="switchStatus(tab.value)">
                            <span class="summary-tab-icon">
                                <i :class="tab.icon"></i>
                            </span>
                            <span class="summary-tab-copy">
                                <strong>{{ tab.count }}</strong>
                                <small>{{ tab.label }}</small>
                            </span>
                        </button>
                    </div>

                    <div class="import-log-toolbar">
                        <div class="import-log-search">
                            <i class="fa fa-search"></i>
                            <input
                                v-model.trim="searchTerm"
                                type="search"
                                :placeholder="'Search in ' + activeStatusLabel + '…'"
                                @input="detailPage = 1">
                        </div>
                        <div class="import-log-meta">
                            Showing
                            <strong>{{ pageStart }}–{{ pageEnd }}</strong>
                            of
                            <strong>{{ filteredLogs.length }}</strong>
                            {{ activeStatusLabel.toLowerCase() }}
                        </div>
                        <div class="import-log-page-size">
                            <span>Per page</span>
                            <select v-model.number="pageSize" @change="detailPage = 1">
                                <option :value="100">100</option>
                                <option :value="200">200</option>
                                <option :value="500">500</option>
                                <option :value="1000">1000</option>
                            </select>
                        </div>
                    </div>

                    <div class="import-log-list" :class="'list-' + activeStatus">
                        <div class="import-log-list-header">
                            <span class="col-line">Line</span>
                            <span class="col-desc">Description</span>
                        </div>

                        <div v-if="pagedLogs.length" class="import-log-list-body">
                            <div
                                v-for="log in pagedLogs"
                                :key="activeStatus + '-' + log.line + '-' + log._index"
                                class="import-log-row"
                                :class="log.status">
                                <span class="col-line">
                                    <span class="line-badge">{{ log.line }}</span>
                                </span>
                                <span class="col-desc" v-html="log.desc ? log.desc : '-'"></span>
                            </div>
                        </div>

                        <div v-else class="import-log-empty">
                            <i class="fa fa-inbox"></i>
                            <strong>No {{ activeStatusLabel.toLowerCase() }} records</strong>
                            <p v-if="searchTerm">Try a different search keyword.</p>
                            <p v-else>There are no items in this category.</p>
                        </div>
                    </div>

                    <div class="import-log-footer">
                        <div class="import-log-pagination" v-if="totalPages > 1">
                            <button type="button" :disabled="detailPage <= 1" @click="goToPage(detailPage - 1)">
                                <i class="fa fa-chevron-left"></i>
                            </button>
                            <span>Page {{ detailPage }} / {{ totalPages }}</span>
                            <button type="button" :disabled="detailPage >= totalPages" @click="goToPage(detailPage + 1)">
                                <i class="fa fa-chevron-right"></i>
                            </button>
                        </div>
                        <div v-else class="import-log-pagination-spacer"></div>
                        <gofix-button label="CLOSE" @click="modals.detail.open = false" noBorder dark></gofix-button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'import-logs',
        props: {
            is_safety_app: {
                type: Boolean,
                default: false,
            },
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['import_logs']));
            return {
                tableConfig:{
                    name: 'account-import-logs',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport:false,
                        tableExport:false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                },
                tableItems: [],
                modals:{
                    detail: {
                        open: false,
                        loading: false,
                        data: null,
                    }
                },
                activeStatus: 'failed',
                searchTerm: '',
                detailPage: 1,
                pageSize: 100,
            }
        },
        computed: {
            detailPayload() {
                const row = this.modals.detail.data;
                if (!row) return null;
                // Row item shape: { data: { count, log } }
                if (row.data && (row.data.log || row.data.count)) return row.data;
                // Already the payload: { count, log }
                if (row.log || row.count) return row;
                return null;
            },
            allLogs() {
                const payload = this.detailPayload;
                if (!payload || !payload.log) return [];

                let logs = [];
                if (Array.isArray(payload.log)) {
                    logs = payload.log;
                } else if (typeof payload.log === 'object') {
                    logs = Object.keys(payload.log).map(function(key) {
                        return payload.log[key];
                    });
                }

                return logs
                    .filter(function(log) { return log && typeof log === 'object'; })
                    .map(function(log, index) {
                        return {
                            line: log.line != null ? log.line : index + 1,
                            status: log.status || '',
                            desc: log.desc || '',
                            _index: index,
                        };
                    })
                    .sort(function(a, b) {
                        return Number(a.line) - Number(b.line);
                    });
            },
            statusCounts() {
                const counts = this.detailPayload ? this.detailPayload.count : null;
                if (counts) {
                    return {
                        failed: Number(counts.failed) || 0,
                        warning: Number(counts.warning) || 0,
                        succeeded: Number(counts.succeeded) || 0,
                    };
                }
                return {
                    failed: this.allLogs.filter(function(log) { return log.status === 'failed'; }).length,
                    warning: this.allLogs.filter(function(log) { return log.status === 'warning'; }).length,
                    succeeded: this.allLogs.filter(function(log) { return log.status === 'succeeded'; }).length,
                };
            },
            statusTabs() {
                return [
                    {
                        value: 'failed',
                        label: 'Error',
                        icon: 'fa fa-times-circle',
                        count: this.statusCounts.failed,
                    },
                    {
                        value: 'warning',
                        label: 'Warning',
                        icon: 'fa fa-exclamation-triangle',
                        count: this.statusCounts.warning,
                    },
                    {
                        value: 'succeeded',
                        label: 'Success',
                        icon: 'fa fa-check-circle',
                        count: this.statusCounts.succeeded,
                    },
                ];
            },
            activeStatusLabel() {
                const tab = this.statusTabs.find(function(item) {
                    return item.value === this.activeStatus;
                }.bind(this));
                return tab ? tab.label : 'All';
            },
            filteredLogs() {
                const status = this.activeStatus;
                const query = (this.searchTerm || '').toLowerCase();
                return this.allLogs.filter(function(log) {
                    if (log.status !== status) return false;
                    if (!query) return true;
                    const line = String(log.line != null ? log.line : '');
                    const desc = String(log.desc || '').replace(/<[^>]*>/g, ' ').toLowerCase();
                    return line.indexOf(query) !== -1 || desc.indexOf(query) !== -1;
                });
            },
            totalPages() {
                return Math.max(1, Math.ceil(this.filteredLogs.length / this.pageSize) || 1);
            },
            pageStart() {
                if (!this.filteredLogs.length) return 0;
                return (this.detailPage - 1) * this.pageSize + 1;
            },
            pageEnd() {
                return Math.min(this.detailPage * this.pageSize, this.filteredLogs.length);
            },
            pagedLogs() {
                const start = (this.detailPage - 1) * this.pageSize;
                return this.filteredLogs.slice(start, start + this.pageSize);
            },
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if (this.is_safety_app) {
                    tableRequest.filter.is_safety = true;
                }
                await this.$store.dispatch("ImportLogController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the import log", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.modals.detail.data = item;
                this.searchTerm = '';
                this.detailPage = 1;
                this.activeStatus = this.getDefaultStatus(item);
                this.modals.detail.open = true;
            },
            getDefaultStatus(item) {
                const payload = item && item.data && (item.data.log || item.data.count)
                    ? item.data
                    : item;
                const count = payload ? payload.count : null;
                if (count) {
                    if (Number(count.failed) > 0) return 'failed';
                    if (Number(count.warning) > 0) return 'warning';
                    if (Number(count.succeeded) > 0) return 'succeeded';
                }
                return 'succeeded';
            },
            switchStatus(status) {
                this.activeStatus = status;
                this.detailPage = 1;
            },
            goToPage(page) {
                if (page < 1 || page > this.totalPages) return;
                this.detailPage = page;
            },
            resetDetailModal() {
                this.modals.detail.data = null;
                this.searchTerm = '';
                this.detailPage = 1;
                this.activeStatus = 'failed';
            },
        }
    }
</script>
